import { Address, ApplicantForIDVDto, ApplicationDto } from "@/lib/DTMWebAPIClient.generated";
import { createApiClient } from "@/lib/Requests";
import { setClickInsightEvents } from "@/lib/util";
import { setIdvId } from "@/slices/applicantSlice";
import { selectHomeAddress } from "@/slices/homeAddressSlice";
import { RootState } from "@/store/dtm";
import SlideTransition from "@/styles/animation/SlideTransition";
import style from "@/styles/pages/VerifyIdentification/VerifyIdentification.module.css";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export default function VerifyIdentification() {
  const dispatch = useDispatch();

  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );
  const credential = useSelector(
    (state: RootState) => state.credential.credential
  );
  const referralProducts = useSelector((state: RootState) => state.referralProducts.products);
  const client = createApiClient({ timeout: 60000, token: credential.accessToken });
  const homeAddress = useSelector(selectHomeAddress);
  let branchOpen = true;

  const findBranch = () => {
    window.open('https://www.meridiancu.ca/Contact-Us/Find-a-Branch-or-ABM.aspx', '_blank');
  }

  useEffect(() => {

    //dispatch(setIdvId(50));
    // create call to IDV Service
    if (applicant.idvId == 0) {
      client.apiIdverificationInbranchidv(new ApplicantForIDVDto({
        alloySessionId: applicant.alloySessionId,
        applicantId: applicant.id,
        primaryAddress: new Address({
          type: "home",
          streetNumber: homeAddress.address.streetNumber,
          streetName: homeAddress.address.streetName,
          streetType: homeAddress.address.streetType,
          streetDirection: homeAddress.address.streetDirection,
          unitNumber: homeAddress.address.unitNumber,
          city: homeAddress.address.city,
          region: homeAddress.address.province,
          postalCode: homeAddress.address.postalCode,
          country: homeAddress.address.country
        }),
        mailingAddress: new Address({
          type: "mailing",
          streetNumber: homeAddress.address.streetNumber,
          streetName: homeAddress.address.streetName,
          streetType: homeAddress.address.streetType,
          streetDirection: homeAddress.address.streetDirection,
          unitNumber: homeAddress.address.unitNumber,
          city: homeAddress.address.city,
          region: homeAddress.address.province,
          postalCode: homeAddress.address.postalCode,
          country: homeAddress.address.country
        }),
        firstName: applicant.firstName,
        lastName: applicant.lastName,
        emailAddress: applicant.isProspect ? credential.email : applicant.email,
        phoneNumber: applicant.phoneNumber,
        phoneType: applicant.phoneType,
        dateOfBirth: `${applicant.dob_year}-${applicant.dob_month}-${applicant.dob_day.length > 1
          ? applicant.dob_day
          : "0" + applicant.dob_day
          }`,
        sin: applicant.sin
      })).then((result) => {
        dispatch(setIdvId(result.id ? result.id : 0));
      }).catch((error) => {
        console.log("Error saving applicant info");
      });
    }

    document.title = "We still need to verify your identity";
    setClickInsightEvents(referralProducts, "applicationFailure", "main", "new", "under review", application.id, applicant);
  }, []);

  useEffect(() => {
    client.apiApplicationsFetch().then((result) => {
      result.applicant = applicant;
      client.apiApplicationsSave(new ApplicationDto({
        applicationData: JSON.stringify(result)
      })).catch((error) => {
        console.log("Error saving applicant info");
      });
    }).catch((error) => {
      console.log("Error saving applicant info");
    });
  }, [applicant]);

  return (
    <SlideTransition>
      <main aria-labelledby="main-content">
        <div className="flex flex-col max-xs:px-3 sm:ml-80 max-md:items-center max-md:mt-20">
          <div className={style.viHeading}>
            <h1>We still need to verify your identity</h1>
            <p className="sub-heading">
              Unfortunately we weren’t able to verify your ID digitally. To continue with your mortgage application
              we will need to verify your identity. Here are your options to verify your identity:
            </p>
            <div className={clsx("mt-5", style.sectionContainer)}>

              <div
                className="flex flex-row justify-between mt-5 mb-5"
              >
                <h4>Visit your nearest Meridian branch</h4>
              </div>
              {branchOpen && (
                <>
                  {" "}
                  <div className="ml-3">
                    <span className="brand-blue-text">
                      1. Schedule an appointment by calling your branch
                    </span>
                    <div className="mb-5">
                      <button className="primary mt-5 h-11 px-6" onClick={findBranch}>Find a Branch</button>
                    </div>
                    <div className="mt-3">
                      <span className="brand-blue-text">
                        2. Bring one piece of government issued photo ID
                      </span>
                      <div className="mt-3">
                        <p>• Canadian Drivers Licence</p>
                        <p>• Canadian Passport</p>
                        <p>• Nexus</p>
                        <p>• Provincial Photo ID Card</p>
                        <p>• Canadian Permanent Resident Card</p>
                        <p>• Canadian Certificate of Indian Status</p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="mb-5"></div>
        </div>
      </main>
    </SlideTransition>
  );
}
